import { dismissNotifications } from 'reapop';
import { notify } from 'reapop'

function error(options) {
    return (dispatch) => {
        dispatch(notify(options.message, "error", options));
    }
}

function success(options) {
    return (dispatch) => {
        dispatch(notify(options.message, "success", options));
    }
}

function warning(options) {
    return (dispatch) => {
        dispatch(notify(options.message, "warning", options));
    }
}

function info(options) {
    return (dispatch) => {
        dispatch(notify(options.message, "info", options));
    }
}

export function throwErrorMessage(errorOptions) {
    return (dispatch) => {
        errorOptions.dismissible = true;
        if(!errorOptions.dismissAfter) {
            errorOptions.dismissAfter = 10000;
        }

        if (errorOptions.errorObject && errorOptions.errorObject.noNetworkError) {
            errorOptions.uid = errorOptions.errorObject.errorCode;
            errorOptions.message = "Appareil hors connexion";
            dispatch(error(errorOptions));
            return;
        }

        dispatch(error(errorOptions));
    }
}

export function throwSuccessMessage(successOptions) {
    return (dispatch) => {
        successOptions.dismissible = true;
        if (!successOptions.dismissAfter)
            successOptions.dismissAfter = 5000;

        dispatch(success(successOptions));
    }
}

export function throwWarning(warningOptions) {
    return (dispatch) => {
        warningOptions.dismissible = true;
        if (!warningOptions.dismissAfter)
            warningOptions.dismissAfter = 5000;

        dispatch(warning(warningOptions));
    }
}

export function throwInfo(infoOptions) {
    return (dispatch) => {        
        if (!infoOptions.forceDismissible) {
            infoOptions.dismissible = true;
        }
        if (!infoOptions.dismissAfter && infoOptions.dismissAfter !== 0)
            infoOptions.dismissAfter = 5000;

        dispatch(info(infoOptions));
    }
}

export function removeAllNotifications() {
    return (dispatch) => {
        dispatch(dismissNotifications());
    }
}

//Gestion d'exceptions provenant du serveur (OpenErp)
export function throwErrorWithGenericExternalBusinessError(errorObject, commonMessage) {
    return (dispatch) => {
        let message = commonMessage

        if (errorObject.message && errorObject.type)
            message = errorObject.message;

        dispatch(throwErrorMessage({
            errorObject: errorObject,
            title: "Erreur",
            message: message,
        }));
    }
}
